import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CartItemsService } from './shared/services/cart-items.service';
import { CommonHttpService } from './shared/services/http.service';
import { HttpModule } from '@angular/http';
import { CartRowsUpdaterService } from './cart/services/cart-rows-updater.service';
import { ResumeUpdaterService } from './cart/services/cart-resume-updater.service';
import { CartResumeService } from './shared/services/cart-resume.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    TranslateLoader, TranslateModule,
    TranslateService
} from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { PaymentStepsService } from './payment/services/payment-steps.service';
import { IdentificationStepsService } from './payment/services/identification-steps.service';
import { CookieService, CookieOptions } from 'angular2-cookie/core';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { OauthService } from './shared/services/oauth.service';
import { AuthenticatedUserRepositoryService } from './payment/services/authenticated-user-repository.service';
import { UnauthenticatedUserRepositoryService } from './payment/services/unauthenticated-user-repository.service';
import { NgxMaskModule } from 'ngx-mask';
import { DeliveryStepsService } from './payment/services/delivery-steps.service';
import { OverlayModule } from 'angular-io-overlay/src/overlay';
import { PasswordRecoveryStepsService } from './payment/services/password-recovery-steps.service';
import { CustomFormsModule } from 'ng2-validation';
import { StoreConfigurationsService } from './shared/services/store-configurations.service';
import { ResponsiveModule } from 'ng2-responsive';
import { MobileScrollToService } from './shared/services/mobile-scroll-to.service';
import { ModalModule } from 'ngx-modialog';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { ExtraFieldValidatonService } from './shared/services/extra-field-validaton.service';
import { ExtraFieldValidationRuleService } from './shared/services/extra-field-validation-rule.service';
import { PaymentService } from './payment/services/payment.service';
import { FreightCalculatorService } from './shared/services/freight-calculator.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { DistanceToDeadlineService } from './payment/services/distance-to-deadline.service';
import { AccountModule } from './account/account.module';
import { CartModule } from './cart/cart.module';
import { PaymentModule } from './payment/payment.module';
import { CompletedModule } from './completed/completed.module';
import { ThumbSourceFactoryService } from './shared/services/thumb-source-factory.service';
import { UrlService } from './shared/services/url.service';
import { Rot13Service } from './shared/services/rot13.service';
import { BetalabsAnalyticsModule } from './betalabs-analytics/betalabs-analytics.module';
import { WebpackTranslateLoader } from './webpack-translate-loader';
import { TranslationConfiguratorService } from './shared/services/translation-configurator.service';
import { AppsService } from './shared/services/apps.service';
import { PointsService } from './shared/services/points.service';

@NgModule({
  declarations: [
      AppComponent
  ],
  imports: [
      AccountModule,
      CartModule,
      PaymentModule,
      CompletedModule,
      BrowserModule,
      CommonModule,
      HttpModule,
      HttpClientModule,
      FormsModule,
      TranslateModule.forRoot({
          loader: {
              provide: TranslateLoader,
              useClass: WebpackTranslateLoader
          }
      }),
      Angular2SocialLoginModule,
      FormsModule,
      ReactiveFormsModule,
      NgxMaskModule,
      AppRoutingModule,
      OverlayModule,
      CustomFormsModule,
      ResponsiveModule,
      ModalModule.forRoot(),
      BootstrapModalModule,
      BrowserAnimationsModule,
      ToastrModule.forRoot({
          timeOut: 10000,
          positionClass: 'toast-top-full-width',
          preventDuplicates: true
      }),
      BetalabsAnalyticsModule
  ],
  providers: [
      CookieService,
      CommonHttpService,
      OauthService,
      UrlService,
      ThumbSourceFactoryService,
      StoreConfigurationsService,
      AppsService,
      ExtraFieldValidatonService,
      ExtraFieldValidationRuleService,
      FreightCalculatorService,
      Rot13Service,
      // common services
      CartItemsService,
      CartResumeService,
      MobileScrollToService,
      // cart services
      CartRowsUpdaterService,
      ResumeUpdaterService,
      // payment services
      PaymentStepsService,
      IdentificationStepsService,
      DeliveryStepsService,
      AuthenticatedUserRepositoryService,
      UnauthenticatedUserRepositoryService,
      PasswordRecoveryStepsService,
      PaymentService,
      DistanceToDeadlineService,
      PointsService,
      { provide: CookieOptions, useValue: {} }
  ],
  bootstrap: [
      AppComponent
  ],
  exports: [
      TranslateModule
  ]
})
export class AppModule {
    constructor(
        public translate: TranslateService
    ) {
        translate.addLangs(TranslationConfiguratorService.availableLanguages);
        translate.setDefaultLang(TranslationConfiguratorService.defaultLanguage);

        for (const lang of TranslationConfiguratorService.availableLanguages) {
            translate.setTranslation(
                lang,
                System.import(`../assets/translations/${lang}.json`)
            );
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/app.module.ts